<template>
  <div class="toZhwyview">
    <!-- totoOwner -->
  </div>
</template>

<script>
export default {
  name: 'toZhwyview',
  created () {
    if (process.env.NODE_ENV === 'development') {
      window.open('https://zjj.sz.gov.cn/zhwy/');
    } else if (process.env.NODE_ENV === 'production') {
      window.open('https://zjj.sz.gov.cn/zhwy/');
    }

    this.$router.go(-1);
  },
}
</script>

<style></style>
